import React from 'react';
import Tooltip from 'react-texty';
import PropTypes from 'prop-types';
import cn from 'classnames';

import TextCopyForTooltip from '../TextCopyForTooltip/TextCopyForTooltip';

import classes from './TextWithTooltip.module.scss';

const TextWithTooltip = ({ text, saveNotification, className }) => {
  if (saveNotification) {
    return (
      <Tooltip
        className={cn(classes.tooltip, className)}
        tooltipClassName={classes.tooltip_body}
        tooltip={
          <TextCopyForTooltip text={text} notification={saveNotification} />
        }
      >
        {text}
      </Tooltip>
    );
  } else {
    return (
      <Tooltip
        className={classes.tooltip}
        tooltipClassName={classes.tooltip_body}
      >
        {text}
      </Tooltip>
    );
  }
};

TextWithTooltip.propTypes = {
  text: PropTypes.string,
  saveNotification: PropTypes.string,
  className: PropTypes.string
};

export default TextWithTooltip;
